import { Label, LoadingWrapper, Tooltip } from "client/CommonComponents"
import { formatPrice } from "utils";

const PurchaseDetail = (props?: any) => {
    const {
        assetItemStatusTemp,
        skipVendorDetail,
        isLoading
    }: any = props;

    return (
        <div className="purchasedetail-bulkorderfleet p-3">
            <LoadingWrapper isLoading={isLoading} data-attribute="PurchaseDetail_Default_LoadingWrapper"> 
            <div>
                <Label data-attribute="PurchaseDetail_Default_Label">Description</Label>
                <Tooltip content={skipVendorDetail ? assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipDesc : assetItemStatusTemp?.purchaseDetails?.description || '-'} data-attribute="PurchaseDetail_Default_Tooltip">
                    <div className="content">{skipVendorDetail ? assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipDesc : assetItemStatusTemp?.purchaseDetails?.description || '-'}</div>
                </Tooltip>
            </div>
            <div>
                <Label data-attribute="PurchaseDetail_Default_Label_2">Purchase Type</Label>
                <Tooltip content={assetItemStatusTemp?.purchaseDetails?.purchaseType || '-'} data-attribute="PurchaseDetail_Default_Tooltip_2">
                    <div className="content">{assetItemStatusTemp?.purchaseDetails?.purchaseType || '-'}</div>
                </Tooltip>
            </div>
            <div>
                <Label data-attribute="PurchaseDetail_Default_Label_3">Registered</Label>
                <Tooltip content={assetItemStatusTemp?.purchaseDetails?.registered || '-'} data-attribute="PurchaseDetail_Default_Tooltip_3">
                    <div className="content">{assetItemStatusTemp?.purchaseDetails?.registered || '-'}</div>
                </Tooltip>
            </div>
            <div>
                <Label data-attribute="PurchaseDetail_Default_Label_4">Asset #</Label>
                <Tooltip content={assetItemStatusTemp?.purchaseDetails?.assetNo || '-'} data-attribute="PurchaseDetail_Default_Tooltip_4">
                    <div className="content">{assetItemStatusTemp?.purchaseDetails?.assetNo || '-'}</div>
                </Tooltip>
            </div>
            <div>
                <Label data-attribute="PurchaseDetail_Default_Label_5">Price Per Unit $</Label>
                <Tooltip content={`${assetItemStatusTemp?.purchaseDetails?.pricePerUnit ? `$ ${formatPrice(assetItemStatusTemp?.purchaseDetails?.pricePerUnit, 2)}` : "-"}`} data-attribute="PurchaseDetail_Default_Tooltip_5">
                    <div className="content">{`${assetItemStatusTemp?.purchaseDetails?.pricePerUnit ? `$ ${formatPrice(assetItemStatusTemp?.purchaseDetails?.pricePerUnit, 2)}` : "-"}`}</div>
                </Tooltip>
            </div>
            <div>
                <Label data-attribute="PurchaseDetail_Default_Label_6">Order Type</Label>
                <Tooltip content={assetItemStatusTemp?.purchaseDetails?.orderType || '-'} data-attribute="PurchaseDetail_Default_Tooltip_6">
                    <div className="content">{assetItemStatusTemp?.purchaseDetails?.orderType || '-'}</div>
                </Tooltip>
            </div>
            <div>
                <Label data-attribute="PurchaseDetail_Default_Label_7">Reason Code</Label>
                <Tooltip content={assetItemStatusTemp?.purchaseDetails?.reasonCode || '-'} data-attribute="PurchaseDetail_Default_Tooltip_7">
                    <div className="content">{assetItemStatusTemp?.purchaseDetails?.reasonCode || '-'}</div>
                </Tooltip>
            </div>
            <div>
                <Label data-attribute="PurchaseDetail_Default_Label_8">Asset Sourcing</Label>
                <Tooltip content={assetItemStatusTemp?.purchaseDetails?.assetSourcing || '-'} data-attribute="PurchaseDetail_Default_Tooltip_8">
                    <div className="content">{assetItemStatusTemp?.purchaseDetails?.assetSourcing || '-'}</div>
                </Tooltip>
            </div>
            {skipVendorDetail ?
                <>
                    <div>
                        <Label data-attribute="PurchaseDetail_Default_Label_9">Unit #</Label>
                        <Tooltip content={assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipUnitNumber || '-'} data-attribute="PurchaseDetail_Default_Tooltip_9">
                            <div className="content">{assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipUnitNumber || '-'}</div>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="PurchaseDetail_Default_Label_10">Model Year</Label>
                        <Tooltip content={assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipModelYear || '-'} data-attribute="PurchaseDetail_Default_Tooltip_10">
                            <div className="content">{assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipModelYear || '-'}</div>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="PurchaseDetail_Default_Label_11">Manuf. code</Label>
                        <Tooltip content={assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipManufac || '-'} data-attribute="PurchaseDetail_Default_Tooltip_11">
                            <div className="content">{assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipManufac || '-'}</div>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="PurchaseDetail_Default_Label_12">Serial/VIN</Label>
                        <Tooltip content={assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipSerialNumber || '-'} data-attribute="PurchaseDetail_Default_Tooltip_12">
                            <div className="content">{assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipSerialNumber || '-'}</div>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="PurchaseDetail_Default_Label_13">GVWR</Label>
                        <Tooltip content={assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipgvw || '-'} data-attribute="PurchaseDetail_Default_Tooltip_13">
                            <div className="content">{assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipgvw || '-'}</div>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="PurchaseDetail_Default_Label_14">Eq. Class code</Label>
                        <Tooltip content={assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipEqClass || '-'} data-attribute="PurchaseDetail_Default_Tooltip_14">
                            <div className="content">{assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cipEqClass || '-'}</div>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="PurchaseDetail_Default_Label_15">CIP PO #</Label>
                        <Tooltip content={assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cippoNumber || '-'} data-attribute="PurchaseDetail_Default_Tooltip_15">
                            <div className="content">{assetItemStatusTemp?.purchaseDetails?.pocipDetails?.cippoNumber || '-'}</div>
                        </Tooltip>
                    </div>
                </>
                : null}
         </LoadingWrapper> 
        </div>
    )
}

export default PurchaseDetail